import React from 'react';
import { BoxIcon } from 'lucide-react';
interface FeatureCardProps {
  icon: BoxIcon;
  title: string;
  color: 'blue' | 'purple' | 'green' | 'orange' | 'red' | 'indigo';
  onClick: () => void;
}
export const FeatureCard: React.FC<FeatureCardProps> = ({
  icon: Icon,
  title,
  color,
  onClick
}) => {
  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    green: 'bg-green-100 text-green-600',
    orange: 'bg-orange-100 text-orange-600',
    red: 'bg-red-100 text-red-600',
    indigo: 'bg-indigo-100 text-indigo-600'
  };
  return <button onClick={onClick} className="bg-white rounded-xl shadow-sm p-4 flex flex-col items-center justify-center transition-transform hover:scale-105" data-id="element-1024">
      <div className={`w-12 h-12 rounded-full ${colorClasses[color]} flex items-center justify-center mb-3`} data-id="element-1025">
        <Icon size={24} data-id="element-1026" />
      </div>
      <span className="text-gray-800 font-medium text-center" data-id="element-1027">{title}</span>
    </button>;
};